// Lesson-time change form — client side of functions/slotChange.js.
//
// Three callables. The two public ones are token-keyed and App-Check-gated
// exactly like the portal claim page; the admin one is behind the same
// send-email permission as the portal claim invite. Nothing here reads
// Firestore directly: the invite collection is Functions-only.
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

// Staff: create the invite and email the parent the link. Returns the URL too,
// so the profile can offer a copy button for a text message.
export async function createSlotChangeInvite({ studentId, recipientEmail, recipientName, customMessage }) {
	const callable = httpsCallable(functions, 'createSlotChangeInvite');
	const { data } = await callable({
		studentId,
		recipientEmail,
		recipientName,
		customMessage: customMessage || '',
		origin: window.location.origin,
	});
	return data;
}

// Public: what the form renders. `state` is open | expired | submitted | revoked.
export async function getSlotChangeInvite(token) {
	const callable = httpsCallable(functions, 'getSlotChangeInvite');
	const { data } = await callable({ token });
	return data;
}

// Public, single-use: the parent's picks. A REQUEST, never a booking.
export async function submitSlotChangeRequest({ token, requestedSlotIds, openToAnything, notes }) {
	const callable = httpsCallable(functions, 'submitSlotChangeRequest');
	const { data } = await callable({ token, requestedSlotIds, openToAnything, notes });
	return data;
}
